import { project as constants } from "store/constants";
import { reduceIsFetching, fetchableInitialState, reduceSetError } from "store/factories/fetchable";


const initialState = {
	...fetchableInitialState,
	content: {
		project: {},
	},
};

export function project(state = initialState, action) {
	switch (action.type) {
		case constants.SINGLE_PROJECT_IS_FETCHING:
			return reduceIsFetching(state, action);
		case constants.SINGLE_PROJECT_SET_ERROR:
			return reduceSetError(state, action.payload);
		case constants.SINGLE_PROJECT_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
					...action.payload,
				},
			};
		case constants.SINGLE_PROJECT_RESET:
			return initialState;
		default:
			return state;
	}
}
